import image1 from "../../Assets/images/SliderImages/image1.jpg";
import image2 from "../../Assets/images/SliderImages/image2.jpg";
import image3 from "../../Assets/images/SliderImages/image3.jpg";
import image4 from "../../Assets/images/SliderImages/image4.jpg";
import image5 from "../../Assets/images/SliderImages/image5.jpg";
import image6 from "../../Assets/images/SliderImages/image6.jpg";
import image7 from "../../Assets/images/SliderImages/image7.jpg";
import image8 from "../../Assets/images/SliderImages/image8.jpg";


export const SliderData = [
  {
    image: image1,
  },
  {
    image: image2,
  },
    {
    image: image3,
  },
    {
    image: image4,
  },
    {
    image: image5,
  },
    {
    image: image6,
  },
    {
    image: image7,
  },
    {
    image: image8,
  },
]
export default SliderData;